// F18: 401 ve giriş yönlendirmelerinin ortak kuralları. Bağımlılığı yok; hem
// `lib/api.ts` (ölü token) hem giriş sayfaları hem `postAuth` buradan okur.
//
// İki kapı var: `/login` (öğrenci) ve `/instructor/login` (eğitmen). Ölü token
// eğitmen alanında düşerse eğitmen kapısına döner; `?next=` ise kişinin kaldığı
// sayfayı taşır ki rapor ortasında düşen öğrenci URL'sini kaybetmesin.
export const NEXT_PARAM = "next";

export function loginPathFor(path: string): "/login" | "/instructor/login" {
  return path.startsWith("/instructor") ? "/instructor/login" : "/login";
}

// Yalnızca uygulama içi göreli yol kabul edilir: `/` ile başlar, `//` ya da
// `/\` ile başlamaz (protokol-göreli açık yönlendirme), giriş sayfasının kendisi
// değildir. Geçersiz değer null döner ve varsayılan hedef kullanılır.
export function safeNext(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  if (raw.startsWith("/login") || raw.startsWith("/instructor/login")) return null;
  return raw;
}

export function withNext(loginPath: string, target: string): string {
  const next = safeNext(target);
  return next ? `${loginPath}?${NEXT_PARAM}=${encodeURIComponent(next)}` : loginPath;
}
